import CompanyInvite from './CompanyInvite';

export default CompanyInvite;
